import { Heading, VStack } from '@chakra-ui/react'
import React from 'react'
import SlideFromEdge, { SlideDirection } from 'src/components/SlideFromEdge/SlideFromEdge'

interface PageNavigationProps {
  title: string
  pageIndex: number
  slideDirection?: SlideDirection
  children: React.ReactNode
}

const PageNavigation: React.FC<PageNavigationProps> = ({
  title,
  pageIndex,
  slideDirection,
  children,
}) => {
  return (
    <SlideFromEdge pageIndex={pageIndex} slideDirection={slideDirection}>
      <VStack width='100%'>
        <Heading textAlign='center' flex='1' width='100%' size='md' py='1.2rem'>
          {title}
        </Heading>
        {children}
      </VStack>
    </SlideFromEdge>
  )
}

export default PageNavigation
